var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgButtonIconError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4116 8.22069L25.9116 23.2207C26.0215 23.3782 26.0294 23.5854 25.9316 23.7507C25.8381 23.9046 25.6716 23.9992 25.4916 24.0007H6.49158C6.3147 23.9882 6.15639 23.8864 6.07158 23.7307C5.97614 23.5741 5.97614 23.3773 6.07158 23.2207L15.5716 8.22069C15.6668 8.08252 15.8238 8 15.9916 8C16.1594 8 16.3164 8.08252 16.4116 8.22069ZM15.9916 9.42069L7.40158 23.0007H24.5816L15.9916 9.42069ZM15.4916 14.4807V18.4807C15.4916 18.7568 15.7154 18.9807 15.9916 18.9807C16.2677 18.9807 16.4916 18.7568 16.4916 18.4807V14.4807C16.4916 14.2045 16.2677 13.9807 15.9916 13.9807C15.7154 13.9807 15.4916 14.2045 15.4916 14.4807ZM16.4916 20.4807C16.4916 20.7568 16.2677 20.9807 15.9916 20.9807C15.7154 20.9807 15.4916 20.7568 15.4916 20.4807C15.4916 20.2045 15.7154 19.9807 15.9916 19.9807C16.2677 19.9807 16.4916 20.2045 16.4916 20.4807Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgButtonIconError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ButtonIconError.b0d76d8f4f93677c81ddc62c88aa728f.svg";